import styled from 'styled-components';

import {colors} from '@app/styles/theme';

export const Wrapper = styled.div`
    display: flex;
    flex-direction: column;
    gap: 10px;
`;

export const Header = styled.div`
    display: flex;
    align-items: center;
    gap: 20px;
    padding: 20px;
    box-shadow: 0 0 2px 0 rgba(0, 0, 0, 0.15);
    background: ${colors.white};

    & > h2 {
        color: ${colors.brandPrimary};
        min-width: 300px;
    }
`;

export const SummaryWrapper = styled.div`
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    grid-template-rows: repeat(2, auto);
    gap: 24px;
    padding: 20px;
    box-shadow: 0 0 2px 0 rgba(0, 0, 0, 0.15);
    background: ${colors.white};

    & > *:last-child {
        grid-column: 1 / -1;
    }
`;

export const BlockWrapper = styled.div`
    display: flex;
    flex-direction: column;
    gap: 18px;
    padding: 24px;
    border: 1px solid #e1e8ef;
    border-radius: 8px;
    color: ${colors.textPrimary};

    & > h4 {
        margin: 0;
        font-size: 24px;
        font-weight: 600;
    }
`;
